import { gql } from "@apollo/client";

export const GQL_CUSTOMER_PUBLIC_AREA_FORM_UPSERT = gql`
   mutation customerPublicAreaFormUpsert($input: PublicAreaInfoInput!) {
      customerPublicAreaFormUpsert(input: $input)
   }
`;
